import { useContext, useState } from 'react';
// import Link from 'next/link';
import Image from 'next/image';
import classNames from 'classnames';
import { useTranslation } from 'next-i18next';
import { Button, ButtonsContainer, ThemeContext } from '@forma/forma-ui-kit';
import RequestDemoModal2 from '@/components/blocks/RequestDemoModal2';
import RequestDemoModal3 from '@/components/blocks/RequestDemoModal3';
import PageBlock from '@/components/PageBlock';
import Logo from '@/components/Logo';
import { analytics } from '@/helpers/analytics';

import styles from './main-banner-3.module.css';

// const lkUrl = process.env.LK_URL;

const BannerButtons = ({ notice, callModal }) => {
  const { t } = useTranslation();
  // const { lang } = useContext(ThemeContext);
  const [isRequestOpen, setRequestOpen] = useState(false);
  const [isRequest3Open, setRequest3Open] = useState(false);

  return (
    <>
      <ButtonsContainer className={styles.buttons}>
        <Button
          // as={Link}
          viewStyle="primary"
          className={styles.button}
          // href={`${lkUrl}/register?lng=${lang}`}
          onClick={() => setRequest3Open(true)}
        >
          {callModal?.button ?? t('start_free')}
        </Button>
        <Button
          // as={Link}
          viewStyle="secondary"
          className={classNames(styles.button, styles.secondary)}
          onClick={() => {
            setRequestOpen(true);
            analytics.clickTryTrial();
          }}
        // href="/request"
        >
          {t('request_demo')}
        </Button>
      </ButtonsContainer>
      <div className={styles.notice}>
        {notice}
      </div>
      <RequestDemoModal2
        open={isRequestOpen}
        onClose={setRequestOpen}
      />
      <RequestDemoModal3
        open={isRequest3Open}
        onClose={setRequest3Open}
        title={callModal?.title}
        description={callModal?.description}
      />
    </>
  );
};

const MainBanner3 = ({ label, title, subtitle, image, notice, callModal }) => {
  const { viewport } = useContext(ThemeContext);
  const isPhone = ['phone', 'tabletS'].includes(viewport);

  return (
    <PageBlock variant="white" className={styles.root}>
      <div className={styles.container}>
        <div className={styles.contentContainer}>
          {label && (
            <div className={styles.label}>
              <Logo className={styles.logo} type="block" /> {label}
            </div>
          )}
          <h1 className={styles.title}>
            {title}
          </h1>
          <p className={styles.subtitle}>
            {subtitle}
          </p>
          {!isPhone && <BannerButtons notice={notice} callModal={callModal} />}
        </div>
        <div className={styles.imageContainer}>
          <Image className={styles.image} src={image.src} alt={label} width={image.width} height={image.height} />
        </div>
        {isPhone && <div><BannerButtons notice={notice} callModal={callModal} /></div>}
      </div>
    </PageBlock>
  );
};

export default MainBanner3;
